import styles from 'storeLocator/mapStyles';

/* eslint-disable no-undef */

const renderInfoWindow = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street} ${item.house}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}">${resources.select}</button></div>`;

    return built;
};

const renderInfoWindowInPost = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street} ${item.house}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow-InPost font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}"}>${resources.select}</button></div>`;

    return built;
};

const renderInfoWindowBRT = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street} ${item.house}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow-BRT font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}"}>${resources.select}</button></div>`;

    return built;
};

const renderInfoWindowPPL = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street} ${item.house}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow-PPL font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}"}>${resources.select}</button></div>`;

    return built;
};

const renderInfoWindowCLSS = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street} ${item.house}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow-CLSS font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}"}>${resources.select}</button></div>`;

    return built;
};

const renderInfoWindowDHL = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow-DHL font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}"}>${resources.select}</button></div>`;

    return built;
};

const renderInfoWindowDPD = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow-DPD font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}"}>${resources.select}</button></div>`;

    return built;
};

const renderInfoWindowHermes = (item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow-${shippingMethodType} font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}"}>${resources.select}</button></div>`;

    return built;
};

const renderInfoWindowFromBFF = (shippingMethodType, item, resources) => {
    let built = ``;
    // Only for pickup point (not for store) we should display the point name in the info window
    if ('name' in item && item.name !== '' && item.name !== null && item.name !== undefined) {
        built += `<span class="store-name strong">${item.name}</span><br>`;
    }
    built += `<p>${item.street} ${item.house}, <br>${item.city} ${item.postcode}</p>`;

    built += `<span class="store-gotomps-box float-right">
        <a target='_blank' href="https://maps.google.com/maps/place/${item.lat},${item.long}"><img src="${$('.findinstore-data-container').data('directions-icon')}" /></a>
        </span>`;

    built += `<div><div class="spacer small"></div><button class="button button-primary js-choose-pickup-infowindow-${shippingMethodType} font-size-12" data-store-id="${item.name}"  data-store-sap="${item.sap}"}>${resources.select}</button></div>`;

    return built;
};

export default class Map {
    constructor ($target, initialCoordinates = [42, 16]) {
        this.$target = $target;
        this.previousQuery = '';
        this.markers = [];
        this.initialCoordinates = initialCoordinates;
        this.initiallyMarkers = []; // Contains all the markers return from the service call
        this.markerCluster = null;
    }

    init () {
        const self = this;
        const latlng = new google.maps.LatLng(this.initialCoordinates[0], this.initialCoordinates[1]);
        const mapOptions = {
            scrollwheel: false,
            zoom: 16,
            center: latlng,
            streetViewControl: false,
            styles
        };

        this.countryCode = document.getElementById('country-code').value;

        this.map = new google.maps.Map(this.$target[0], mapOptions);
        this.bounds = new google.maps.LatLngBounds();
        this.infowindow = new google.maps.InfoWindow();

        // Reset zoom after fit bounds
        google.maps.event.addListener(self.map, 'zoom_changed', function () {
            var zoomChangeBoundsListener = google.maps.event.addListener(self.map, 'bounds_changed', function (event) {
                if (this.getZoom() > 12 && this.initialZoom === true) {
                    // Change max/min zoom here
                    this.setZoom(12);
                    this.initialZoom = false;
                }
                google.maps.event.removeListener(zoomChangeBoundsListener);
            });
        });

        this.map.initialZoom = true;

        // Handle Geocoding request (look for city, zipcode, ..)
        $('body').on('submit', '#pickuppoint-form', (e) => {
            const query = $('.pickup-input-group-field').val();
            self.geocode(query, self.countryCode, this.$target);
            e.preventDefault();
        });
    }

    /**
     * Update the text list and the in bounds counter
     */

    centerMapOnCoordinates (coordinates = {lat: 0, lng: 0}, zoom = 16) {
        this.map.setCenter({ lat: coordinates.lat, lng: coordinates.lng });
        try {
            this.map.setZoom(zoom);
        } catch (err) {
            // Avoid markercluster maxZoom bug
            ;
        }
    }

    fitBounds (stores) {
        // Fit the all the store marks in the center of a minimum bounds when any store has been found.
        if (stores && stores.length) {
            this.map.fitBounds(this.bounds);

            // If only one store is found, center and zoom on it
            if (stores.length === 1) {
                if ('store' in stores[0] && stores[0].store) {
                    this.centerMapOnCoordinates({ lat: stores[0].store.latitude, lng: stores[0].store.longitude }, 16);
                } else if ('lat' in stores[0] && 'long' in stores[0] && stores[0].lat && stores[0].long) {
                    this.centerMapOnCoordinates({ lat: stores[0].lat, lng: stores[0].long }, 16);
                }
            }
        }
    }

    updateMarkers (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindow(element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateMarkersInPost (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindowInPost(element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            /*
            google.maps.event.addListener(marker, 'click', function (e) {
                $('body').trigger('pickuppoint:clickOnMarker', e.id);
                // map.setCenter(marker.getPosition()); // sets center without animation
            });
            */

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateMarkersBRT (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindowBRT(element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateMarkersPPL (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindowPPL(element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            /*
            google.maps.event.addListener(marker, 'click', function (e) {
                $('body').trigger('pickuppoint:clickOnMarker', e.id);
                // map.setCenter(marker.getPosition()); // sets center without animation
            });
            */

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateMarkersCLSS (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindowCLSS(element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateMarkersDHL (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindowDHL(element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            /*
            google.maps.event.addListener(marker, 'click', function (e) {
                $('body').trigger('pickuppoint:clickOnMarker', e.id);
                // map.setCenter(marker.getPosition()); // sets center without animation
            });
            */

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateMarkersDPD (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindowDPD(element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateMarkersHermes (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);

            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindowHermes(element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            /*
            google.maps.event.addListener(marker, 'click', function (e) {
                $('body').trigger('pickuppoint:clickOnMarker', e.id);
                // map.setCenter(marker.getPosition()); // sets center without animation
            });
            */

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateMarkersFromBFF (shippingMethodType, stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        const labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let labelIndex = 0;

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.lat, element.long);
            let label = '';
            let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
            let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
            label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
            labelIndex++;
            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.lat,
                long: element.long,
                label: {
                    text: label,
                    color: 'white',
                    fontSize: '10px',
                    lineHeight: '14px',
                    fontWeight: '600',
                    fontFamily: "'MessinaSansWeb', Arial, sans-serif",
                    className: 'map-marker-label'
                }
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindowFromBFF(shippingMethodType, element, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonBlackMarker', element);
            });

            /*
            google.maps.event.addListener(marker, 'click', function (e) {
                $('body').trigger('pickuppoint:clickOnMarker', e.id);
                // map.setCenter(marker.getPosition()); // sets center without animation
            });
            */

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(stores);

        this.initiallyMarkers = this.markers;
    }

    updateCoordinates (coordinates) {
        // If there are no markers yet, center zoom to current position
        // if (!this.markers.length) {
        this.centerMapOnCoordinates({ lat: coordinates.lat, lng: coordinates.long }, 16);
        // }
    }

    geocode (query = '', countryCode = 'US', $target) {
        // eslint-disable-next-line no-undef
        if (query.length < 3 || query === this.previousQuery) {
            return null;
        }

        // Save previous query to avoid Geocoding the same location multiple times
        this.previousQuery = query;

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': query, 'componentRestrictions': {'country': countryCode}}, (res, status) => {
            if (res && res.length && status === 'OK') {
                var address = res[0].address_components;
                var zipcode = '';
                var locality = '';

                for (var i = 0; i < address.length; i++) {
                    if (address[i].types.includes('postal_code')) {
                        zipcode = address[i].short_name;
                    }
                    if (address[i].types.includes('locality')) {
                        locality = address[i].short_name;
                    }
                }
                const coords = {
                    lat: res[0].geometry.location.lat(),
                    long: res[0].geometry.location.lng(),
                    zipcode: zipcode,
                    locality: locality
                };
                $target.trigger('pickupPointGeocode:update', {
                    success: status === 'OK',
                    data: coords
                });
            } else {
                $target.trigger('pickupPointGeocode:update', {
                    success: status === 'OK',
                    status: status
                });
            }
        });
    }
}
